import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";
import MathUtil from "@/util/MathUtil";

class PayMyPartService {
    createAmountForRefund(amount){
        let amountForRefund = MathUtil.displayTwoDecimals(amount).replace(',', ''); //Just remove comma
        return parseInt(amountForRefund);
    }
    refund(amount, refundedPayment, cartItems, refundedTipsAmount, orderDocumentId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/payment/payMyPartRefund';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                merchant: user.merchant,
                amount: this.createAmountForRefund(amount),
                refundedPayment: refundedPayment,
                cartItems: cartItems,
                refundedTipsAmount : refundedTipsAmount,
                orderDocumentId: orderDocumentId
            },
            {headers: basicAuth });
    }
}

export default new PayMyPartService();
